/* unplugin-vue-components disabled */import script from "./MenuTableBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuTableBlock.vue?vue&type=script&lang=ts&setup=true"

import "./MenuTableBlock.vue?vue&type=style&index=0&id=f12407f6&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f12407f6"]])

export default __exports__